import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "error"];
import { registerQuery, useQuery } from 'data-fetching-client';
import { useEffect } from 'react';
import GlobalHomeAPI from '../api/GlobalHomeAPI';
const isEligibleQuery = registerQuery({
  fieldName: 'isGlobalHomeEligible',
  fetcher: () => GlobalHomeAPI.isEligible()
});
export const useIsGlobalHomeEligible = () => {
  const _useQuery = useQuery(isEligibleQuery),
    {
      data,
      error
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  useEffect(() => {
    if (error) {
      console.error('Error fetching global home eligibility', error);
    }
  }, [error]);
  return Object.assign({
    isEligible: data && data.isGlobalHomeEligible.isEligible,
    error
  }, rest);
};